import React, { FC, forwardRef } from "react";
import { AgGridReact } from "ag-grid-react";
import {
  ColDef,
  ColGroupDef,
} from "ag-grid-community/dist/types/core/entities/colDef";
import { AgGridReactProps } from "ag-grid-react/dist/types/src/shared/interfaces";

import "./styles.css";

interface TableProps {
  // any по документашке https://ag-grid.com/javascript-data-grid/typescript-generics/
  rowData: any[] | null;
  colDefs: (ColDef<any> | ColGroupDef<any>)[] | null;
  height?: number;
  ref?: any;
}

export const Table: FC<AgGridReactProps & TableProps> = forwardRef(
  ({ rowData, colDefs, height = 500, ...rest }, ref: any) => (
    <div className="ag-theme-quartz" style={{ height: height }}>
      <AgGridReact
        {...rest}
        ref={ref}
        rowData={rowData}
        suppressHorizontalScroll={false}
        columnDefs={colDefs}
        noRowsOverlayComponent={() => "Пусто."}
      />
    </div>
  )
);
